var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"border-bottom border-light px-3 w-auto"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.$navigation.breadcrumbs}}),_c('Actions',{attrs:{"actions":_vm.$navigation.actions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }